import { render, staticRenderFns } from "./AvailableGoldBalance.vue?vue&type=template&id=14f4b9dc&"
import script from "./AvailableGoldBalance.vue?vue&type=script&lang=js&"
export * from "./AvailableGoldBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports